import { types } from 'mobx-state-tree';
import { currentStudentRoutesQuery } from '@app-types/graphql-types';
import { Route } from './Route';

export const Student = types
  .model('UserModel', {
    id: types.maybe(types.number),
    firstName: '',
    lastName: '',
    email: types.maybeNull(types.string),
    firebaseUID: '',
    regNumber: '',
    courseID: types.maybeNull(types.string),
    intakeID: types.maybeNull(types.string),
    routes: types.optional(types.array(Route), []),
    status: '',
    familiarizationFormSubmitted: false,
    exitInterviewFormSubmitted: false,
  })
  .actions((self) => ({
    addStudent(
      id: number,
      firstName: string,
      lastName: string,
      email: string | null,
      firebaseUID: string,
      regNumber: string,
      courseID: string,
      intakeID: string,
      status: string,
      routes: currentStudentRoutesQuery['current_student_routes_route'],
      familiarizationFormSubmitted: boolean,
      exitInterviewFormSubmitted: boolean,
    ) {
      self.id = id;
      self.regNumber = regNumber;
      self.firstName = firstName;
      self.lastName = lastName;
      self.email = email;
      self.firebaseUID = firebaseUID;
      self.regNumber = regNumber;
      self.courseID = courseID;
      self.intakeID = intakeID;
      self.status = status;
      self.exitInterviewFormSubmitted = exitInterviewFormSubmitted;
      self.familiarizationFormSubmitted = familiarizationFormSubmitted;

      routes.forEach((route) => {
        let parent;

        if (route.current_user_route.current_user_route_parent) {
          parent = {
            id: route.current_user_route.current_user_route_parent.id,
            name: route.current_user_route.current_user_route_parent.name,
          };
        }

        self.routes.push({
          id: route.current_user_route.id,
          name: route.current_user_route.name,
          componentName: route.current_user_route.componentName,
          path: route.current_user_route.path,
          iconName: route.current_user_route.iconName,
          dummy: route.current_user_route.dummy,
          showInMenu: route.current_user_route.showInMenu,
          order: route.current_user_route.order,
          parent: parent || null,
        });
      });
    },
    updateFamiliarizationFormSubmitted(familiarizationFormSubmitted: boolean) {
      self.familiarizationFormSubmitted = familiarizationFormSubmitted;
    },
    updateEexitInterviewFormSubmitted(exitInterviewFormSubmitted: boolean) {
      self.exitInterviewFormSubmitted = exitInterviewFormSubmitted;
    },
  }));
